'use strict';

module.exports = /* @ngInject */ function ($scope, $attrs, $http, feSourcingWaiverTabService) {
	$scope.orderId = "";
	$scope.error = false;
	$scope.sourcingWaiverExplanationsTab = null;

	/**
	 * Initialise all required variables.
	 * @param orderId
	 */
	$scope.initSourcingWaiverExplanation = function (orderId) {
		$scope.error = false;
		$scope.orderId = orderId;
		getSourcingWaiverExplanations(orderId);
	};

	function getSourcingWaiverExplanations(orderId) {
		feSourcingWaiverTabService.receiveExplanationForOrder.query(
			{
				orderId: orderId
			})
			.$promise.then(
			function (result) {
				$scope.sourcingWaiverExplanationsTab = result;
			}, function (error) {
				console.error(error);
				$scope.error = true;
				$scope.sourcingWaiverExplanationsTab = [];
			}
		);
	}

};
